import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JobDataRoutingModule } from './job-data-routing.module';
import { JobDataComponent } from './job-data.component';
import {SharedModule} from '../../../theme/shared/shared.module';
import {NgbCarouselModule, NgbProgressbarModule, NgbTabsetModule} from '@ng-bootstrap/ng-bootstrap';
import {TableModule} from 'primeng/table';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {ToastModule} from 'primeng/toast';
import {ViewJobComponent} from '../view-job/view-job.component';
import {CalendarModule} from 'primeng/calendar';
import {InputSwitchModule} from 'primeng/inputswitch';
import {TooltipModule} from 'primeng/tooltip';


@NgModule({
  declarations: [JobDataComponent,ViewJobComponent],
  imports: [
    CommonModule,
    JobDataRoutingModule,
    SharedModule,
    NgbProgressbarModule,
    NgbTabsetModule,
    ToastModule,
    TableModule,
    InputSwitchModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    MessageModule,
    MessagesModule,
    TooltipModule,
    NgbCarouselModule,
    CalendarModule
  ],
  exports:[ViewJobComponent]
})
export class JobDataModule { }
